module.exports = __webpack_public_path__ + "img/22.ed73092a.png";